import React from 'react';
import Chip from '@mui/material/Chip';
import Icon from '@mui/material/Icon';
import { alpha } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { safeText, toneForAttendance } from '../utils/rsvpFormatters';

function labelForStatus(status) {
  const value = String(status || '').toUpperCase();
  if (value === 'YES') return 'Katilacagim';
  if (value === 'NO') return 'Katilamayacagim';
  return 'Bekliyor';
}

export function RsvpHeader({ companyName, tokenMasked, attStatus }) {
  return (
    <MDBox
      sx={(theme) => ({
        px: { xs: 1.25, sm: 1.6 },
        py: 1.35,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexWrap: 'wrap',
        background:
          theme.palette.mode === 'dark'
            ? `linear-gradient(135deg, ${alpha('#0ea5e9', 0.18)} 0%, ${alpha(
                '#0f172a',
                0.88
              )} 100%)`
            : `linear-gradient(135deg, ${alpha('#0ea5e9', 0.14)} 0%, ${alpha(
                '#ffffff',
                0.96
              )} 100%)`,
        borderBottom: `1px solid ${alpha(
          theme.palette.text.primary,
          theme.palette.mode === 'dark' ? 0.12 : 0.08
        )}`,
      })}
    >
      <MDBox sx={{ minWidth: 0 }}>
        <MDTypography sx={{ fontWeight: 900, fontSize: 17, lineHeight: 1.1 }} noWrap>
          {safeText(companyName, 'Solisup')}
        </MDTypography>
        <MDTypography sx={{ fontSize: 12, opacity: 0.74, mt: 0.25 }} noWrap>
          Seans katilim onayi
        </MDTypography>
      </MDBox>

      <MDBox display="flex" alignItems="center" gap={0.7} flexWrap="wrap" justifyContent="flex-end">
        {tokenMasked ? (
          <Chip
            size="small"
            icon={<Icon sx={{ fontSize: 15 }}>vpn_key</Icon>}
            label={tokenMasked}
            sx={{ borderRadius: '10px', height: 28, fontWeight: 800 }}
          />
        ) : null}

        <Chip
          size="small"
          color={toneForAttendance(attStatus)}
          label={labelForStatus(attStatus)}
          sx={{ borderRadius: '10px', height: 28, fontWeight: 900 }}
        />
      </MDBox>
    </MDBox>
  );
}
